import styled from "styled-components";

export default styled.div`
  position: absolute;
  bottom: -100%;
  width: 100%;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: -8px -8px 36px rgba(0, 0, 0, 0.15),
    8px 8px 36px rgba(0, 0, 0, 0.15);
`;
